// DS: DEV3
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import random from 'lodash/random';
import CompletionPopup from '../CompletionPopup';
export const GiveLlamaPopup = ({ username, isLoading, isSuccess, textIndex: textIndexArg, errorReason, onModalClose, init })=>{
    const { t, i18n } = useTranslation();
    useEffect(()=>init && init(), [
        init
    ]);
    // if not sent in, randomize it the first time
    const [textIndex] = useState(textIndexArg || random(1, 4));
    const specificErrorKey = `giveLlamaPopup.failure.text.${errorReason}`;
    const errorMessageKey = errorReason && i18n.exists(specificErrorKey) ? specificErrorKey : 'giveLlamaPopup.failure.text.default';
    return /*#__PURE__*/ React.createElement(CompletionPopup, {
        isLoading: isLoading,
        imageWidth: 89,
        imageHeight: 133,
        imageWidthMobile: 58,
        imageHeightMobile: 88,
        onClose: onModalClose,
        image: "https://st.deviantart.net/eclipse/popups/give-popups/llama.svg",
        title: isSuccess ? t(`giveLlamaPopup.case${textIndex}.header`) : t([
            `giveLlamaPopup.failure.header.${errorReason}`,
            'giveLlamaPopup.failure.header.default'
        ]),
        message: isSuccess ? t('giveLlamaPopup.successMessage', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            username: /*#__PURE__*/ React.createElement("strong", null, username)
        }) : t(errorMessageKey, {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            username: /*#__PURE__*/ React.createElement("strong", null, username)
        }),
        buttonLabel: isSuccess ? t([
            `giveLlamaPopup.case${textIndex}.button.label`,
            'common.dismiss'
        ]) : t([
            `giveLlamaPopup.failure.button.${errorReason}`,
            'giveLlamaPopup.failure.button.default'
        ])
    });
};
GiveLlamaPopup.displayName = 'GiveLlamaPopup';
export default GiveLlamaPopup;

//# sourceMappingURL=GiveLlamaPopup.js.map